<template>
  <van-popup
    v-model="visible"
    round
    class="celebrate-dialog-popup"
    overlay-class="celebrate-dialog-overlay"
    get-container="body"
    :close-on-click-overlay="false"
  >
    <div class="celebrate" v-if="items.length" :class="{ 'is-multiple': items.length > 1 }">
      <div class="celebrate__title">恭喜猜中</div>
      <div class="celebrate__results" :class="{ 'is-multiple': items.length > 1 }">
        <div v-for="(item, index) in items" :key="itemKey(item, index)" class="celebrate__result">
          <div class="celebrate__round">{{ stageLabel(item) }} · {{ matchDateText(item) }}</div>
          <div class="celebrate__teams">{{ resultText(item) }}</div>
          <div class="celebrate__pick">你猜中 · {{ chosenTeam(item) }}胜</div>
        </div>
      </div>
      <div class="celebrate__chance">{{ chanceText }}</div>
      <div class="celebrate__desc">
        <span>前往「抽奖中心」100% 抽取好礼</span>
        <span>多场猜中机会可累计使用</span>
      </div>
      <button class="celebrate__go" @click="$emit('go-lottery')">去抽奖中心</button>
      <button class="celebrate__later" @click="$emit('close')">稍后再说</button>
    </div>
  </van-popup>
</template>

<script>
import { roundLabel } from '../utils'

export default {
  name: 'WorldCupQuizCelebrateDialog',
  props: {
    show: Boolean,
    items: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    chanceText () {
      return this.items.length > 1 ? `获得 ${this.items.length} 次抽奖机会` : '获得一次抽奖机会'
    },
    visible: {
      get () {
        return this.show
      },
      set (value) {
        if (!value) this.$emit('close')
      }
    }
  },
  methods: {
    matchDateText (match) {
      if (!match) return '--'
      const fields = [
        'deadline_time',
        'match_time',
        'match_start_time',
        'start_time',
        'begin_time',
        'game_time',
        'date_time',
        'match_date'
      ]
      const value = fields.map(field => match[field]).find(item => item)
      return this.formatDate(value)
    },
    formatDate (value) {
      const date = this.parseDate(value)
      if (!date) return '--'
      const pad = n => String(n).padStart(2, '0')
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
    },
    parseDate (value) {
      if (!value) return null
      const text = String(value).trim()
      if (!text) return null
      if (/^\d+$/.test(text)) {
        const timestamp = Number(text)
        const date = new Date(timestamp > 100000000000 ? timestamp : timestamp * 1000)
        return Number.isNaN(date.getTime()) ? null : date
      }
      const date = new Date(text.replace(/-/g, '/'))
      return Number.isNaN(date.getTime()) ? null : date
    },
    stageLabel (match) {
      return match ? roundLabel(match) : '比赛'
    },
    itemKey (match, index) {
      return `${match.match_key || match.match_id || match.schedule_id || index}-${index}`
    },
    resultText (match) {
      const score = (match && match.result_score ? String(match.result_score) : '-').replace(/\s*-\s*/g, ' : ')
      return `${match.team_a || '--'} ${score} ${match.team_b || '--'}`
    },
    chosenTeam (match) {
      return (match && match.my_bet && match.my_bet.chosen_team) || '--'
    }
  }
}
</script>

<style scoped lang="scss">
.celebrate {
  position: relative;
  width: 313px;
  height: 437px;
  padding-top: 24px;
  overflow: hidden;
  box-sizing: border-box;
  color: #fff;
  text-align: center;
  border: 2px solid #ffe669;
  border-radius: 12px;
  background:
    url('~@/assets/image/worldcupQuiz/match-card-field.png') center/cover no-repeat,
    linear-gradient(180deg, #008d46 0%, #00540f 100%);
  box-shadow: inset 0 4px 30px rgba(90, 255, 120, .5);
}

.celebrate.is-multiple {
  height: 505px;
}

.celebrate__title {
  width: 144px;
  height: 44px;
  margin: 0 auto;
  color: #fff6b6;
  font-family: "Alimama ShuHeiTi", "PingFang SC", sans-serif;
  font-size: 36px;
  font-weight: 700;
  line-height: 44px;
  letter-spacing: 0;
  text-shadow:
    0 2px 0 #00540f,
    0 -2px 0 #00540f,
    2px 0 0 #00540f,
    -2px 0 0 #00540f,
    0 4px 6px rgba(0, 0, 0, .32);
}

.celebrate__results {
  width: 235px;
  margin: 11px auto 0;
}

.celebrate__results.is-multiple {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 176px;
  overflow-y: auto;
}

.celebrate__result {
  width: 235px;
  height: 100px;
  padding-top: 14px;
  box-sizing: border-box;
  flex: 0 0 auto;
  border: 2px solid #ffe744;
  border-radius: 12px;
  background: #00450c;
}

.celebrate__results.is-multiple .celebrate__result {
  height: 84px;
  padding-top: 9px;
}

.celebrate__results.is-multiple .celebrate__teams {
  margin-top: 4px;
}

.celebrate__results.is-multiple .celebrate__pick {
  margin-top: 4px;
}

.celebrate__round {
  color: #fff;
  font-size: 12px;
  font-weight: 400;
  line-height: 17px;
}

.celebrate__teams {
  margin-top: 7px;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
}

.celebrate__pick {
  margin-top: 8px;
  color: #ffe744;
  font-size: 12px;
  font-weight: 600;
  line-height: 17px;
}

.celebrate__chance {
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  min-width: 144px;
  max-width: 235px;
  height: 25px;
  margin: 16px auto 0;
  padding: 3px 16px 2px;
  box-sizing: border-box;
  border-radius: 23px;
  color: #1e5f2a;
  background: #ffe744;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  white-space: nowrap;
}

.celebrate__desc {
  width: 210px;
  margin: 16px auto 0;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}

.celebrate__desc span {
  display: block;
  white-space: nowrap;
}

button {
  display: block;
  width: 243px;
  height: 48px;
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
  border: 0;
  border-radius: 35px;
  font-size: 20px;
  font-weight: 600;
  line-height: 48px;
}

.celebrate__go {
  margin-top: 16px;
  color: #1e5f2a;
  background: linear-gradient(180deg, #ffe648 0%, #ffb65a 100%);
}

.celebrate__later {
  margin-top: 16px;
  border: 2px solid #ffe744;
  color: #ffe744;
  background: transparent;
}
</style>

<style lang="scss">
.celebrate-dialog-popup.van-popup {
  top: calc(50% + 29px);
  z-index: 120 !important;
  overflow: visible;
  background: transparent;
}

.celebrate-dialog-overlay {
  z-index: 119 !important;
  background: rgba(0, 0, 0, .6);
}
</style>
